'use client';

import React from 'react';
import { useUrlSync } from '@/scripts/hooks/useUrlSync';

// This component initializes the store from URL parameters
const StoreInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Use our custom hook to sync URL state with application state
  useUrlSync();

  return <>{children}</>;
};

// This HOC wraps a component with the StoreInitializer
export const withStore = <P extends object>(Component: React.ComponentType<P>): React.FC<P> => {
  return (props: P) => (
    <StoreInitializer>
      <Component {...props} />
    </StoreInitializer>
  );
};
